import React from "react";
import { Switch as HeadlessSwitch } from "@headlessui/react";
import { SwitchProps } from "../interfaces";

export const Switch: React.FC<SwitchProps> = (props) => {
  const { checked, onChange, disabled, isLoading, label } = props;

  return (
    <div className="inline-flex items-center gap-2">
      <HeadlessSwitch
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className={`inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors duration-200 ${
          checked
            ? "bg-black disabled:bg-black/50"
            : "bg-gray-200 disabled:bg-gray-200/80"
        } focus:outline-none focus-visible:ring-2 focus-visible:ring-white/75 disabled:cursor-not-allowed`}
      >
        {isLoading ? (
          <div
            className={`h-5 w-5 animate-spin rounded-full border-2 border-white border-t-transparent ${
              checked ? "ml-auto" : ""
            }`}
          />
        ) : (
          <span
            aria-hidden="true"
            className={`pointer-events-none block h-5 w-5 rounded-full bg-white shadow-lg ring-0 transition-transform ${
              checked ? "translate-x-5" : "translate-x-0"
            }`}
          />
        )}
      </HeadlessSwitch>
      {label && (
        <span className="text-sm font-normal text-gray-900">{label}</span>
      )}
    </div>
  );
};
